import PropTypes from 'prop-types';
import Color from 'color';

export default function contrast(background) {
  let color = 'black';
  const C = Color(background);
  const r = C.contrast(Color('red'));
  const b = C.contrast(Color('black'));
  const w = C.contrast(Color('white'));
  if (w > b || r < 1.3) {
    color = '#FFFFFF';
  } else {
    color = '#000000';
  }
  return color;
}

contrast.propTypes = {
  background: PropTypes.string.isRequired,
};
